import { UIViewEnum } from "../enums/UIViewEnum";
import { eLynxObjectTypeEnum } from "../enums/eLynxObjectType";
import { getDeviceRoute, getGroupRoute, getTagRoute, getTankBatteryRoute, getTankRoute, getWellRoute } from "./RouteHelpers";
import { IUIUserFavoriteRouteDetailModel } from "../../services/ui-personalization-data-service/Models";
import { NavigationSource } from "../enums/NavigationSource";

export function createUrlFromRouteDetail(routeDetail: IUIUserFavoriteRouteDetailModel, navSrc?: NavigationSource): { url: string, state: unknown; } {
    let url: string = "";
    const currentViewID = routeDetail.uiView ?? UIViewEnum.None;

    switch (routeDetail.objectType) {

        case eLynxObjectTypeEnum.Group:
            url = getGroupRoute(currentViewID, routeDetail?.objectID as number);
            break;

        case eLynxObjectTypeEnum.Device:
            url = getDeviceRoute(currentViewID, routeDetail?.groupID, routeDetail?.wellID, routeDetail.objectID);
            break;

        case eLynxObjectTypeEnum.Well:
            url = getWellRoute(currentViewID, routeDetail.groupID, routeDetail.objectID);
            break;

        case eLynxObjectTypeEnum.Tank:
            url = getTankRoute(currentViewID, routeDetail.groupID, routeDetail.deviceID, routeDetail.tankBatteryID, routeDetail.objectID);
            break;

        case eLynxObjectTypeEnum.TankBattery:
            url = getTankBatteryRoute(currentViewID, routeDetail.groupID, routeDetail.objectID);
            break;

        case eLynxObjectTypeEnum.Tag:
            url = getTagRoute(currentViewID, routeDetail.groupID, routeDetail.wellID, routeDetail.deviceID, routeDetail.tankBatteryID, routeDetail.tankID, routeDetail.objectID);
            break;
    }

    if (routeDetail.searchCriteria) {
        url = `${url}&searchCriteria=${routeDetail.searchCriteria}`;
    }

    if (navSrc) {
        url = `${url}&navSrc=${navSrc}`;
    }

    const state = routeDetail.configurationID
        ? {
            configurationID: routeDetail.configurationID
        }
        : {};

    return { url, state };
}
